import React , {useState, useEffect} from "react";
import { Navbar } from "./Navbar";
import { TopOptionsBar} from "./TopOptionsBar";
import { UnfinishedBooking } from "./UnfinishedBooking";
import { CatalogContext } from "../Translator/withTranslation";
import { RenderContext } from "../Context/Ssr";
import { LocaleContext } from "../Context/Locale";
import { CurrencyContext } from "../Context/Currency";
import { ParameterContext } from "../Context/Parameter";

const ResponsiveHeaderComponent = (props) => {
    const [mobile, setMobile] = useState(props.mobile);
    const [tablet, setTablet] = useState(props.tablet);

    const resizeHandler = (e) => {
        setMobile(e.detail.properties.mobile);
        setTablet(e.detail.properties.tablet);
    }
    
    useEffect( () => {
            document.addEventListener("CheckWindowResize", resizeHandler);
            return () => {
                document.removeEventListener("CheckWindowResize", resizeHandler);
            };
        }, [mobile, setMobile, tablet, setTablet]
    );

    return (
        <div className={(props.className ? props.className : '')}>
            <UnfinishedBooking
            data={props.unfinishedBookingData}
            mobile={mobile}
            tablet={tablet}
            />
            {!mobile && !tablet ?
            <TopOptionsBar
            currency={props.currency}
            chatWithUsLabel={props.chatWithUsLabel}
            landingPagesIntl={props.landingPagesIntl}
            aiLandingpagesIntl={props.aiLandingpagesIntl}
            languageSelectorOptions={props.languageSelectorOptions}
            mobile={mobile}
            inverseDomainLocales={props.inverseDomainLocales}
            searchURLBase={props.searchURLBase}
            locale={props.locale}
            /> : ''}
            <ParameterContext.Consumer>
                { value => {
                    const parameterContext = value;
                    return (
                        <RenderContext.Consumer>
                        { value => {
                            return (
                                <div>
                                <Navbar
                                    mobile={mobile}
                                    tablet={tablet}
                                    currency={props.currency}
                                    landingPagesIntl={props.landingPagesIntl}
                                    languageSelectorOptions={props.languageSelectorOptions}
                                    renderContext={value}
                                    parameterContext={parameterContext}
                                    locale={props.locale}
                                    searchURLBase={props.searchURLBase}
                                    chatWithUsLabel={props.chatWithUsLabel}
                                    />
                                </div>
                            )
                            }
                        }
                    </RenderContext.Consumer>
                    );
                }}
            </ParameterContext.Consumer>
        </div>
    );
}

export const ResponsiveHeader = (initialProps, context) => {
    context.route = (initialProps.route) ? initialProps.route : '';
    return (
        <ParameterContext.Provider value={initialProps.parameter}>
            <LocaleContext.Provider value={initialProps.locale}>
                <CatalogContext.Provider value={initialProps.catalog}>
                    <RenderContext.Provider value={context}>
                            <CurrencyContext.Provider value={initialProps.currency}>
                                <ResponsiveHeaderComponent { ...initialProps} />
                            </CurrencyContext.Provider>
                    </RenderContext.Provider>
                </CatalogContext.Provider>
            </LocaleContext.Provider>
        </ParameterContext.Provider>
    );
};